import styled, { css } from 'styled-components';
import { P as PopperTrigger } from '../Popper/Popper.styles-3041670f.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-701df069.js';
import { I as Icon } from '../Icon/Icon-258a20fc.js';
import { B as Button } from '../Button/Button-07cad199.js';

const getMobileMarginTopStyle = () => ({
  $small
}) => $small ? '1px' : '3px';
const DropdownIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30039089__sc-amnlzo-0"
})(["margin-top:1px;margin-inline-start:", ";margin-inline-end:0;flex:0 0 auto;color:", ";pointer-events:none;", ""], ({
  $small
}) => $small ? '6px' : '8px', ({
  $disabled,
  theme
}) => !$disabled ? theme.dropdown.icon.color : theme.dropdown.icon.colorDisabled, isMobile(css(["margin-top:", ";"], getMobileMarginTopStyle())));
DropdownIcon.displayName = 'DropdownIcon';
const DropdownButtonContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30039089__sc-amnlzo-1"
})(["overflow:hidden;text-overflow:ellipsis;"]);
DropdownButtonContent.displayName = 'DropdownButtonContent';
const DropdownButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-30039089__sc-amnlzo-2"
})(["display:", ";flex-direction:row;flex-wrap:nowrap;justify-content:space-between;align-content:center;align-items:center;box-sizing:border-box;:hover{> ", "{color:", ";}}", ""], ({
  $inline
}) => $inline ? 'inline-flex' : 'flex', DropdownIcon, ({
  disabled,
  theme
}) => !disabled ? theme.dropdown.icon.colorHover : theme.dropdown.icon.colorDisabled, ({
  $error,
  theme
}) => $error && `
    border: thin solid ${theme.form.input.error.borderColor};
    :active {
      border: thin solid ${theme.form.input.error.borderColor};
    }
  `);
DropdownButton.displayName = 'DropdownButton';
const Wrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30039089__sc-amnlzo-3"
})(["width:", ";padding:0;font-weight:initial;display:inline-block;vertical-align:bottom;> ", "{width:100%;}> ", "{", "}", ""], ({
  $fullWidth
}) => $fullWidth ? '100%' : 'auto', PopperTrigger, DropdownButton, ({
  $fullWidth
}) => $fullWidth && `
      width: 100%;
      text-align: left;
      position: relative;
    `, isMobile(css(["width:100%;> ", "{width:100%;text-align:left;position:relative;}"], DropdownButton)));
Wrapper.displayName = 'Wrapper';
const PopperContentContainerWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30039089__sc-amnlzo-4"
})(["padding:", "px 0px;", ";box-sizing:border-box;"], ({
  $noMaxHeight
}) => $noMaxHeight ? 0 : 7, ({
  $fullWidth,
  $minWidth
}) => {
  /* Only set a min-width if we get a positive number. Add 2px for the border thickness */
  const minWidth = $minWidth && $minWidth >= 0 ? $minWidth + 2 : undefined;
  return minWidth ? `
      width: ${$fullWidth ? `${minWidth}px` : 'auto'};
      min-width: ${minWidth}px;
    ` : '';
});
const OverflowWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30039089__sc-amnlzo-5"
})(["", " overflow-x:hidden;overflow-y:auto;"], ({
  $noMaxHeight,
  theme
}) => !$noMaxHeight && `max-height: calc(${theme.dropdown.maxHeight} - 14px);`);

export { DropdownButtonContent as D, OverflowWrapper as O, PopperContentContainerWrapper as P, Wrapper as W, DropdownIcon as a, DropdownButton as b };
//# sourceMappingURL=Dropdown.styles-c0a8d087.js.map
